import React, { useState } from 'react'
import TextInput from '../TextInput'
import CustomButton from '../CustomButton'
import { FromToDateValidator } from '../../../validations/StatisticsCaptureValidations'
import ErrorText from '../ErrorText'

type Props = {
  applyDateFilter: any
  className?: string
}

const DateRangePicker = (props: Props) => {
  const { applyDateFilter, className } = props
  const [fromDate, setFromDate] = useState<any>(null)
  const [toDate, setToDate] = useState<any>(null)
  const [errors, setErrors] = useState({}) as any

  const handleApply = (e: any) => {
    e.preventDefault()
    let { errors, isValid } = FromToDateValidator({ fromDate, toDate })
    if (isValid) {
      applyDateFilter(fromDate, toDate)
      setFromDate(null)
      setToDate(null)
    }

    setErrors(errors)
  }

  const handleFromDateChange = (e: any) => {
    const newFromDate = new Date(e.target.value)
    if (!toDate || newFromDate <= new Date(toDate)) {
      setFromDate(e.target.value)
    } else {
      alert('From date cannot be greater than To date.')
    }
  }

  const handleToDateChange = (e: any) => {
    const newToDate = new Date(e.target.value)
    if (!fromDate || newToDate >= new Date(fromDate)) {
      setToDate(e.target.value)
    } else {
      alert('To date cannot be earlier than From date.')
    }
  }

  return (
    <form className={` ${className ? className : 'flex w-full md:w-auto flex-col md:flex-row md:items-center'}`} onSubmit={handleApply}>
      <span className="pr-2">From</span>
      <div>
        <TextInput type={'date'} value={fromDate || ''} onChange={handleFromDateChange} className={`mt-1.5 py-2 !w-[145px]`} id={'fromDate'} maxDate={toDate} />
        <ErrorText text={errors.fromDate} />
      </div>

      <span className="px-2">To</span>
      <div>
        <TextInput type={'date'} value={toDate || ''} onChange={handleToDateChange} className={`mt-1.5 py-2 !w-[145px]`} id={'toDate'} minDate={fromDate} />
        <ErrorText text={errors.toDate} />
      </div>
      <CustomButton disabled={fromDate === null || toDate === null} loader={false} type="submit" className="h-10 !mt-2 !sm:mt-0 !ml-2 w-[60px]">
        Apply
      </CustomButton>
    </form>
  )
}

export default DateRangePicker
